<template>
  <div class="form-floating mb-3">
    <input
      type="email"
      class="form-control admin_input"
      :class="v.$error ? 'is-invalid' : ''"
      required
      v-model="email"
      :placeholder="placeholder"
      id="floatingInput"
    />
    <label for="floatingInput">{{ label }}</label>

    <div class="invalid-feedback fw-bolder" v-if="v.$error">
      <span v-if="!v.required"> Email is required..! </span>
      <span v-if="v.required && v.$invalid"> Enter valid email address..!</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    classProps: {
      type: String,
      required: false,
      default: "",
    },
    v: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    email: {
      get() {
        return this.value;
      },
      set(value) {
        this.v.$touch();
        this.$emit("input", value);
      },
    },
  },
};
</script>
